import script from "./GenresFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./GenresFooter.vue?vue&type=script&setup=true&lang=js"

import "./GenresFooter.vue?vue&type=style&index=0&id=14471b6a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14471b6a"]])

export default __exports__